import clsx from 'clsx';

type Props = {
  checked?: boolean;
  label: string;
  className?: string;
};

export default function OptionButton({checked, label, className}: Props) {
  return (
    <div
      className={clsx([
        'cursor-pointer py-3 px-2 text-sm leading-none',
        'transition-colors duration-300 ease-out hover:text-neutral-900',
        checked
          ? 'border-black text-neutral-900'
          : 'border-transparent text-neutral-400',
        className,
      ])}
    >
      {label}
    </div>
  );
}
